import React, { useState } from "react";
import style from "./Nav.module.css";
import ajnasymbole from "../../../Assets/ajnasymbole.svg";
import save from "../../../Assets/saveIcon.svg";
import notificationIcon from "../../../Assets/notification.png";
import email from "../../../Assets/email.png";
import profile from "../../../Assets/profile.svg";
import Hamburger from "../Hamburger/Hamburger";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Popup from "../popover";
import Profilepopup from "../Profilepopup";
import searchIcon from "../../../Assets/searchIcon.svg";
import Ajnavidyalogo from "../../../Assets/Ajnavidyalogo.svg";
import { useEffect } from "react";
import message2 from "../../../Assets/message2.svg";
import { notification } from "socket";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [newMessage, setNewMessage] = useState(0);
  const [notificationMessage, setNotificationMessage] = useState([]);

  useEffect(() => {
    const locPath = location.pathname;
    const locPathArr = locPath.split("/");
    if (locPathArr[locPathArr.length - 1] === "findjob") {
      let current_active_tab = document.querySelector(".activeTab");
      current_active_tab?.classList?.remove("activeTab");
      const getTab = document.getElementById("findjob");
      getTab.classList.add("activeTab");
    } else if (locPathArr[locPathArr.length - 1] === "myapplication") {
      let current_active_tab = document.querySelector(".activeTab");
      current_active_tab?.classList.remove("activeTab");
      const getTab = document.getElementById("myapplication");
      getTab.classList.add("activeTab");
    } else if (locPathArr[locPathArr.length - 1] === "invites") {
      let current_active_tab = document.querySelector(".activeTab");
      current_active_tab?.classList.remove("activeTab");
      const getTab = document.getElementById("invites");
      getTab.classList.add("activeTab");
    } else {
      let current_active_tab = document.querySelector(".activeTab");
      current_active_tab?.classList.remove("activeTab");
      const getTab = document.getElementById("findjob");
      getTab.classList.remove("activeTab");
    }
  }, [location.pathname]);

  const tabChage = (element) => {
    let current_active_tab = document.querySelector(".activeTab");
    current_active_tab.classList.remove("activeTab");
    element.classList.add("activeTab");
  };

  const room = JSON.parse(localStorage.getItem("user"))?._id;
  const name = JSON.parse(localStorage.getItem("user"))?.name;

  useEffect(() => {
    notification.emit("login", { room, name }, (err) => {
      if (err) {
        return;
      } else {
      }
    });
    notification.on("response", (data) => {
      setNotificationMessage(data);
    });
  }, [notification]);

  useEffect(() => {
    notification.on("historical_messages", function (messages) {
      if (messages[0]?.room === room) {
        setNotificationMessage(messages?.reverse()?.slice(0, 5));
      }
    });
    notification.on("message", function (data) {
      if (data.room === room) {
        setNotificationMessage((prev) => [
          {
            ...data,
            message: data.text,
          },
          ...prev,
        ]);
        setNewMessage((prev) => prev + 1);
      }
    });
  }, [notification]);

  return (
    <div className={style.mainCont}>
      <div className={style.container}>
        <div className={style.ajnvidyaCont}>
          <div>
            <Hamburger />
          </div>
          <div
            className={style.logo}
            onClick={() => navigate("/hiring/student/findjob")}
          >
            <img src={Ajnavidyalogo} alt="" />
          </div>
          {/* <div
            className={style.ajnavidyaTxt}
            onClick={() => navigate('/hiring/student/findjob')}
          >
            Ajna<span>Vidya</span>
          </div> */}
        </div>
        <div className={style.categaryCont}>
          <Link to="/hiring/student/findjob" className="Link">
            <div className="activeTab" id="findjob" style={{ padding: "18px" }}>
              Jobs
            </div>
          </Link>
          <Link to="/hiring/student/myapplication" className="Link">
            <div id="myapplication" style={{ padding: "18px" }}>
              My Application
            </div>
          </Link>
          <Link to="/hiring/student/invites" className="Link">
            <div id="invites" style={{ padding: "25px" }}>
              Invites
            </div>
          </Link>
          {/* <div>Business</div> */}
        </div>
        <div className={style.profileCont}>
          <div
            className={style.saveContCont}
            // style={{
            //   backgroundColor: location.pathname.includes("savejobs")
            //     ? "#6c56fb"
            //     : "transparent",
            // }}
          >
            <Link to="/hiring/student/savejobs" className="Link">
              <img
                src={save}
                alt=""
                // style={{
                //   color: location.pathname.includes("savejobs")
                //     ? "white"
                //     : "black",
                // }}
              />
            </Link>
          </div>
          <div className={style.searchContCont}>
            <img src={searchIcon} alt="" />
          </div>
          <div className={style.notification}>
            <div
              className={style.popCont}
              style={{ position: "relative" }}
              onClick={() => setNewMessage(0)}
            >
              {newMessage > 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "10px",
                    fontSize: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    backgroundColor: "#6C56FB",
                    width: "20px",
                    borderRadius: "50%",
                    height: "20px",
                  }}
                >
                  {newMessage > 0 && newMessage}
                </div>
              )}
              <Popup notificationMessage={notificationMessage} />
            </div>
          </div>
          <div className={style.emailCont}>
            <Link to="/hiring/student/chat/#">
              <img src={message2} alt="" />
            </Link>
          </div>
          <div className={style.userCont}>
            <Profilepopup />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
